// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportListModal-cls1_bo7","cls2":"ReportListModal-cls2_H9u ReportListModal-cls1_bo7"};